import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { ISiteConfigService } from '../../../core';
import { ISessionService } from '../../../services';
import { Dto } from '../../../data';
let template = require('./sign-in-card.html');

class SignInCardComponent extends ComponentRegistration {

    constructor() {
        super('signInCard', {
            controller: SignInCardController,
            templateUrl: template,
            controllerAs: 'signInCard',
            bindings: {
                scope: "@",
                redirectRoute: "@",
                onSuccess: "&"
            }
        });
    }
}

interface ISignInCardController {
    onEnter(keyIdentifier): void;
    validate(): void;
    onSignInClick(): void;
    onForgotPasswordClick(): void;
}

class SignInCardController implements ISignInCardController {
    private static $inject: Array<string> = ['$rootRouter', 'SiteConfig', 'Session'];

    //private fields
    private isBadCredentials: Boolean = false;
    private email: string = '';
    private password: string = '';
    private badAccountStateForLogin: boolean;
    private accountStateMessage: string;
    private signInCardForm: ng.IFormController;

    //bindings
    private scope: string;
    private redirectRoute: string;
    private onSuccess: Function;

    constructor(private $router: ng.Router,
        private SiteConfig: ISiteConfigService,
        private Session: ISessionService) {

        console.log('SignInCardController loaded');

    }

    public $onInit(): void {
        this.badAccountStateForLogin = false;
        this.accountStateMessage = "";

        if (!this.scope)
            throw "A security scope is required";
        console.log('SignInCardController activated');
        
        setTimeout(() => {
            let tmp = ng.element(document.getElementById("email")).val();
            if (tmp) {
                document.getElementById("password").focus();
            }
        }, 500);        
    }

    public onEnter(keyIdentifier): void {
        if (keyIdentifier === "Enter") {
            this.onSignInClick();
        }
    }

    public validate(): void {

    }

    public onSignInClick(): void {
        this.badAccountStateForLogin = false;
        this.accountStateMessage = "";

        this.Session.createSession({
            scope: this.scope,
            username: this.email,
            password: this.password
        }).then((context) => {
            if (context && context.userClaims) {

                this.raiseOnSuccessEvent();
                if (this.redirectRoute === "SELF") return;

                if (this.Session.isAccountHolder() && context.account) {
                    if (context.account.status === Dto.AccountStatus.Active
                        && this.redirectRoute) {
                        this.$router.navigate([this.redirectRoute]);
                    }
                    else {
                        this.badAccountStateForLogin = true;
                        this.accountStateMessage = (context.account.status === Dto.AccountStatus.Deactivated)
                            ? "Your account has been deactivated."
                            : "The account has not been activated.";
                        this.Session.reset();                     
                    }
                }
                else if (this.Session.isAdmin()) {
                    this.$router.navigate(["Admin"]);
                }
                else {
                    this.badAccountStateForLogin = true;
                    this.accountStateMessage = "Unknown error occured.";
                }    
            }
            else {
                this.isBadCredentials = true;
            }

        }).catch((e) => {
            this.isBadCredentials = true;
        });
    }

    private raiseOnSuccessEvent() {
        if (typeof this.onSuccess === 'function') {
            this.onSuccess();
        }
    }

    public onForgotPasswordClick(): void {
        this.$router.navigate(['ForgotPassword']);
    }

}

let sgnincdComponent = new SignInCardComponent();
export default sgnincdComponent;
export { sgnincdComponent as SignInCardComponent, ISignInCardController, SignInCardController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/security/user-controls/sign-in-card.ts